export const BRAZIL_UF_OPTIONS = [
    { value: 'AC', label: 'AC — Acre' },
    { value: 'AL', label: 'AL — Alagoas' },
    { value: 'AP', label: 'AP — Amapá' },
    { value: 'AM', label: 'AM — Amazonas' },
    { value: 'BA', label: 'BA — Bahia' },
    { value: 'CE', label: 'CE — Ceará' },
    { value: 'DF', label: 'DF — Distrito Federal' },
    { value: 'ES', label: 'ES — Espírito Santo' },
    { value: 'GO', label: 'GO — Goiás' },
    { value: 'MA', label: 'MA — Maranhão' },
    { value: 'MT', label: 'MT — Mato Grosso' },
    { value: 'MS', label: 'MS — Mato Grosso do Sul' },
    { value: 'MG', label: 'MG — Minas Gerais' },
    { value: 'PA', label: 'PA — Pará' },
    { value: 'PB', label: 'PB — Paraíba' },
    { value: 'PR', label: 'PR — Paraná' },
    { value: 'PE', label: 'PE — Pernambuco' },
    { value: 'PI', label: 'PI — Piauí' },
    { value: 'RJ', label: 'RJ — Rio de Janeiro' },
    { value: 'RN', label: 'RN — Rio Grande do Norte' },
    { value: 'RS', label: 'RS — Rio Grande do Sul' },
    { value: 'RO', label: 'RO — Rondônia' },
    { value: 'RR', label: 'RR — Roraima' },
    { value: 'SC', label: 'SC — Santa Catarina' },
    { value: 'SP', label: 'SP — São Paulo' },
    { value: 'SE', label: 'SE — Sergipe' },
    { value: 'TO', label: 'TO — Tocantins' },
];

const UF_BY_NAME = {
    acre: 'AC',
    alagoas: 'AL',
    amapa: 'AP',
    amazonas: 'AM',
    bahia: 'BA',
    ceara: 'CE',
    'distrito federal': 'DF',
    'espirito santo': 'ES',
    goias: 'GO',
    maranhao: 'MA',
    'mato grosso': 'MT',
    'mato grosso do sul': 'MS',
    'minas gerais': 'MG',
    para: 'PA',
    paraiba: 'PB',
    parana: 'PR',
    pernambuco: 'PE',
    piaui: 'PI',
    'rio de janeiro': 'RJ',
    'rio grande do norte': 'RN',
    'rio grande do sul': 'RS',
    rondonia: 'RO',
    roraima: 'RR',
    'santa catarina': 'SC',
    'sao paulo': 'SP',
    sergipe: 'SE',
    tocantins: 'TO',
};

function foldUfKey(value) {
    return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z]+/g, ' ')
        .trim();
}

/** Valor do select: sempre a sigla, mesmo se o cadastro ainda tiver "Ceará". */
export function brazilUfValue(raw) {
    const trimmed = String(raw || '').trim();
    if (!trimmed) return '';
    const upper = trimmed.toUpperCase();
    if (BRAZIL_UF_OPTIONS.some(option => option.value === upper)) return upper;
    return UF_BY_NAME[foldUfKey(trimmed)] || '';
}
